import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, resolveComponent as _resolveComponent, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "font-light block ml-auto"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Uzupełnij formularz i kliknij ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Zapisz", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" aby dodać nowy dokument ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "py-6"
}
const _hoisted_8 = { class: "flex flex-col space-y-4 md:flex-row md:space-y-0 md:justify-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Pobierz dokumenty", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Dodaj dokument", -1)

import moment from 'moment'
import { ref, computed } from 'vue'
import { UiCard, UiLabelsGroup, UiButton, UiTitle } from '@/components/common/ui'
import { ITableData, ERowTypes } from '@/types/interfaces/table'
import {
    useAdviceDeliveryReactions,
    AdviceDeliveryReaction,
} from '@/composables/useAdviceDeliveryReactions'
import { reactive } from '@vue/reactivity'
import DataTable from '../table/DataTable.vue'
import TheFallback from '../common/TheFallback.vue'
import AdviceDeliveryReactionAddNewDocumentForm from './AdviceDeliveryReactionAddNewDocumentForm.vue'

type Props = {
    adviceDeliveryReactions: AdviceDeliveryReaction[]
    adviceId: number
}

export default /*#__PURE__*/_defineComponent({
  props: {
    adviceDeliveryReactions: { type: Array, required: true },
    adviceId: { type: Number, required: true }
  },
  setup(__props: any) {

const props = __props as {
    adviceDeliveryReactions: AdviceDeliveryReaction[]
    adviceId: number
}


const tableData: ITableData = reactive({ head: [], body: [] })

tableData.head = ['Data', 'Status', 'Pliki', 'Komentarz kierowcy']
tableData.body = computed(() =>
    props.adviceDeliveryReactions.map(row => {
        return [
            row.createdAt ? moment(row.createdAt).format('DD.MM.YYYY, go\\d\\z: HH:MM') : '',
            row.deliveryReactionStatus.name,
            {
                type: ERowTypes.COMPONENT,
                component: UiLabelsGroup,
                componentConfig: {
                    labels: row.images ? row.images.map(image => image.fileName) : [],
                },
            },
            row.comment,
        ]
    }),
)

const canDownloadFile = computed(
    () =>
        (props.adviceDeliveryReactions ? props.adviceDeliveryReactions : []).length > 0 &&
        props.adviceDeliveryReactions
            .map(row => (row.images.length > 0 ? 'filesExists' : null))
            .some(row => row === 'filesExists'),
)

const { downloadDocumentsZip } = useAdviceDeliveryReactions()
const isDownloadingFile = ref<boolean>(false)
const fetchDocumentsHistoryZipFile = async () => {
    isDownloadingFile.value = true
    try {
        await downloadDocumentsZip(props.adviceId)
    } finally {
        isDownloadingFile.value = false
    }
}

const wantToAddNewDocument = ref<boolean>(false)

return (_ctx: any,_cache: any) => {
  const _component_IconDownload = _resolveComponent("IconDownload")!
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createBlock(_unref(UiCard), null, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(UiTitle), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(wantToAddNewDocument.value ? 'Dodaj nowy dokument' : 'Historia dostawy'), 1)
          ]),
          _: 1
        }),
        (wantToAddNewDocument.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      (!wantToAddNewDocument.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (props.adviceDeliveryReactions.length != 0)
              ? (_openBlock(), _createBlock(DataTable, {
                  key: 0,
                  data: _unref(tableData),
                  "horizontal-on-mobile": "",
                  "cell-class-on-mobile": "bg-primary bg-opacity-10 animate-fade-in"
                }, {
                  "row-title": _withCtx((slotProps) => [
                    _createTextVNode(" # " + _toDisplayString(Number(slotProps.index) + 1), 1)
                  ]),
                  _: 1
                }, 8, ["data"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(TheFallback)
                ]))
          ], 64))
        : (_openBlock(), _createBlock(AdviceDeliveryReactionAddNewDocumentForm, {
            key: 1,
            "advice-id": props.adviceId,
            class: "animate-fade-in",
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (wantToAddNewDocument.value = false))
          }, null, 8, ["advice-id"]))
    ]),
    _: 2
  }, [
    (!wantToAddNewDocument.value)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(UiButton), {
                outline: "",
                loading: isDownloadingFile.value,
                disabled: !_unref(canDownloadFile),
                onClick: fetchDocumentsHistoryZipFile
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconDownload),
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_unref(UiButton), {
                primary: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (wantToAddNewDocument.value = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_IconCross)
                ]),
                _: 1
              })
            ])
          ])
        }
      : undefined
  ]), 1024))
}
}

})